import { ListItemButton, ListItemIcon } from '@mui/material';
import { SidebarLink } from '../common/TextLabel';
import styled from '@emotion/styled';

export default function MenuItem({ children = <></>, open, path, end = false, label }) {
  return (
    <SidebarLink to={path} end={end}
                 className={navData => (navData.isActive ? 'active' : 'inactive')}>
      <ListItemButton>
        <ListItemIcon>{children}</ListItemIcon>
        {open && label}
      </ListItemButton>
    </SidebarLink>
  );
}

const StyledListItemButton = styled(ListItemButton)`
    svg {
    fill: rgb(72, 162, 250);
  }
`;

export const MenuItemWithoutLink = ({
  children = <></>, open, label, onClick,
}) => <StyledListItemButton onClick={onClick}>
  <ListItemIcon>{children}</ListItemIcon>
  {open && label}
</StyledListItemButton>;

